module.exports = __webpack_public_path__ + "img/logo.cc697745.png";